import React, { JSX } from "react";
import { Box } from "@mui/material";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Button from "@mui/material/Button";
import Popper from "@mui/material/Popper";
import { push } from "connected-react-router";
import { updateBooking } from "../../actions/booking";
import { Booking } from "../../interfaces/BookingInterfaces";
import { useAppDispatch } from "../../store/hooks";
import { ServiceProvider } from "../../interfaces/ServiceProvidersInterface";
import { tl } from "../../components/translate";
import BookingServiceProviderUpdaterSelect from "./BookingServiceProviderUpdaterSelect";

interface Props {
  booking: Booking;
}

function AssignServiceProvider({ booking }: Props): JSX.Element {
  const [openSpAssignPopOver, setOpenSpAssignPopOver] = React.useState(false);
  const [selectedSp, setSelectedSp] = React.useState<ServiceProvider | null>(null);
  const anchorRef = React.useRef(null);
  const dispatch = useAppDispatch();
  return (
    <Box>
      <Button
        ref={anchorRef}
        onClick={() => setOpenSpAssignPopOver(true)}
        variant="outlined"
        size="small"
      >
        Assign Service Provider
      </Button>
      <Popper
        sx={{ zIndex: 1 }}
        open={openSpAssignPopOver}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement="top-start"
      >
        {({ TransitionProps }) => (
          <Grow
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...TransitionProps}
            style={{
              transformOrigin: "center bottom"
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={() => setOpenSpAssignPopOver(false)}>
                <Box
                  sx={{
                    padding: "16px",
                    border: "1px solid #908f8f",
                    boxShadow: "0px 0px 3px 3px #c7c7c754"
                  }}
                >
                  <BookingServiceProviderUpdaterSelect onChange={setSelectedSp} />
                  <Box textAlign="right" marginTop="16px">
                    <Button
                      sx={{ marginLeft: "32px" }}
                      onClick={() => setOpenSpAssignPopOver(false)}
                      data-testmation="bookingHandleCancelButton"
                    >
                      {tl("booking.cancel")}
                    </Button>
                    <Button
                      sx={{ marginLeft: "8px" }}
                      variant="contained"
                      color="primary"
                      disabled={!selectedSp}
                      onClick={async () => {
                        if (selectedSp) {
                          await dispatch(
                            updateBooking(Number(booking.id), {
                              serviceProviderId: selectedSp.id
                            })
                          );
                          sessionStorage.setItem("spApplied", "true");
                          setOpenSpAssignPopOver(false);
                          dispatch(push(`/calendar?serviceProviderId=${selectedSp.id}`));
                        }
                      }}
                    >
                      Assign
                    </Button>
                  </Box>
                </Box>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
}

export default AssignServiceProvider;
